// Every popup on the two rows, for a person hovering: what this is, and what
// a colour means, in a sentence or two. How each number is computed, where it
// comes from and why it is drawn the way it is lives in README.md ("Stages"),
// for whoever changes the flow; nothing here needs to carry it.

export const PIPELINE_HINTS = {
  phones: (minutes) =>
    `Phones with the mic on right now. Red: one says it's recording but nothing has reached us for ${minutes} min.`,
  phonesStopped:
    "Phones that stopped recording and haven't since, by how. Died: the app stopped and no goodbye reached us; the phone fills in why when it's next opened.",
  phonesFiltered:
    "Can't be narrowed by seal cause or build: those describe spans, and this counts phones.",
  phonesAccount:
    "This account's mic right now, and when we last heard from it.",
  declaredPipe:
    'How long after recording stops the phone tells us. Long means the phone was asleep or offline, or waiting its turn: reclip-08 declares a span only when it can start uploading it, and on cellular holds short ones back up to 30 min.',
  declared:
    'Recording arrives in spans: up to 30 minutes, cut into one-minute segments. The phone declares a span, then uploads it.',
  uploadPipe:
    'How long the upload takes. Red: audio that never arrived, though the phone that recorded it has been back since.',
  notUploaded:
    "Audio the server gave up waiting for, for a reason that isn't a fault: the app hasn't been opened since (it can still send it), the person moved to a new install, or nothing from them in a week.",
  safe: 'Every segment arrived intact, so the phone can delete its copy. Coverage: how much of the recording time we actually hold; on reclip-08, time paused while a quote or another app played counts as not held.',
  routedPipe: 'How long until the router has listened to a span.',
  routed:
    'The share of minutes with speech in them: these go on to be transcribed. Red: a span left waiting too long.',
  routedSkipped: 'Minutes with no speech. Kept, but not transcribed.',
  levelGate:
    'Quiet audio a loudness gate would skip. Measuring only: nothing is skipped.',
  transcribedPipe: 'How long until a span is transcribed.',
  transcribed:
    'Hours of speech transcribed. Red: a span still waiting long enough to risk losing it.',
  transcribedSkipped:
    "Speech the budget didn't cover. Skipped, not queued for later.",
  creditsWouldSkip:
    'What the per-person budget would skip if it were on. Measuring only: nothing is skipped.',
  selectedPipe: 'How long picking quotes takes once a span is transcribed.',
  quotes: {
    withhold:
      "Moments picked as worth hearing again. Ones that sound like TV or music are withheld: the owner doesn't see them and gets no push.",
    shadow:
      'Moments picked as worth hearing again. TV or music is only marked for now; nothing is withheld.',
    off: 'Moments picked as worth hearing again.',
  },
}

export const LOOP_HINTS = {
  pushPipe:
    'From the end of a moment to the push about it. Red: a push that failed.',
  pushed:
    "Pushes sent: one for each new quote, plus friends' new quotes, comments and friend requests. Grey below: skipped on purpose, never a failure.",
  notPushed: 'Quotes we chose not to push, and why.',
  friendsDropped:
    'Friend pushes dropped at send time: nothing new to say, or the friendship ended.',
  tapPipe:
    'Share of pushes that opened the app, of those to phones that report back. Some taps go unreported, so this is a floor.',
  visited: 'Pushes that opened the app.',
  playPipe: 'Share of those visits where someone listened.',
  heard:
    'Visits from a push where someone listened. Below: how many heard the quote the push was about.',
  sharePipe:
    "Share of friendships where one friend heard the other's quotes in the window.",
  friends:
    'Friendships a quote travelled along, either way. Below: how many went both ways, and new friendships.',
}

export const STAR_HINTS = {
  momentToPush:
    'From the end of a moment to the push about it: the number the product is judged by. Median for the window, with p90.',
  endToSafe:
    'From the end of recording to the audio being safe here. Median for the window. No quote was pushed, so moment → push has nothing to show.',
}
